import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

function Image({ className, src, alt, objectFit, style }) {
  if (!src) return null;
  const image = getImage(src);
  // if slice is known to break when using GatsbyImage, use override
  if (image) {
    return (
      <GatsbyImage
        image={image}
        alt={alt}
        className={className}
        objectFit={objectFit}
        style={style}
      />
    );
  }
  return <img src={src.publicURL} alt={alt} className={className} />;
}

Image.propTypes = {
  src: PropTypes.shape().isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  objectFit: PropTypes.string,
  style: PropTypes.shape(),
};

Image.defaultProps = {
  alt: '',
  className: null,
  objectFit: 'contain',
  style: null,
};

export default Image;
